<template>
  <div>
    <div class="bandeau">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-1">
          </div>
          <div class="col-sm-6">
            <div style="padding:5px 0px; margin-bottom: 20px; font-size:30px; color:#666;">
              <a href="#/" class="none">{{ $t('installProg') }}</a>
            </div>
          </div>
          <div class="col-sm-3" style="text-align:right">
            <div style="padding:5px 0px; margin-bottom: 20px; font-size:30px; color:#666;">
              <a class="btn btn-light" style="margin-left: 10px;" href="#/">{{ $t('exit') }}</a>
              <a class="btn btn-light" style="margin-left:10px;" v-on:click="oups">{{ $t('reloadTest') }}</a>
            </div>
          </div>
          <div class="col-sm-1">
          </div>
        </div>
      </div>
          <!--
        <div class="zenter">
            <div style="padding:5px 0px; margin-bottom: 20px; font-size:30px; color:#666;">

            </div>
        </div>
      -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopBar',
  data: function() {
    return {
      dbs: [],
      truc : 1,
    }
  },
  computed: {
      login () {
        return 1
      }
  },
  created() {

  },
  methods : {
    oups(){
      this.$root.$emit('runSetup', {'toto' : 'tttt'}) //like this
    }
  }
}
</script>
<style scoped>
.bandeau {
    margin-top: 20px;
    color:#fff; border-bottom:5px #11a9cc solid; font-size: 20px; min-height: 18px; line-height: 24px; padding: 2px; font-weight: bold;
}
.zenter {
    position:relative;
    margin:0px auto;
    width: 950px;
    padding: 5px 0;
}
.big-title{
    font-size: 32px;
    padding:10px 15px;
    border-bottom: 1px solid #ddd;
    font-family: 'Lucida Grande', sans-serif;
    margin-bottom: 10px;
}
.steps {
    position: relative;
    margin-top: 20px;
    margin-left: 50px;
    margin-right: 20px;
    padding: 0;
}
.steps .step {
    position: relative;
    margin: 5px auto;
}
.steps .step:after {
    clear: both;
    display: block;
    height: 5px;
    content: " ";
}
.steps .title {
    float: left;
    line-height: 24px;
    font-size: 18px;
    font-weight: bold;
}
.steps .state {
    float: right;
    padding-right: 10px;
}
.steps .zerr {
    clear: both;
    display: block;
    padding: 20px 10px 10px 5px;
    /*
    text-align: center;
    color:#b22222;*/
}
.steps .state img {
    height: 20px;
}
.mess {
    text-align: center;
    color:#b22222;
}
.mess a {
    color:#b22222;
}
.menu {
    font-family: 'proxima-nova',Proxima Nova,'Helvetica Neue',Helvetica,sans-serif;
    color:#888;
    font-size:14px; text-transform: uppercase; font-size: 13px;
    padding:4px 10px;
    margin:5px;
    background: #f6f6f6;
    cursor: pointer;
}
.active{
    color:#fff;
    background: #0f66aa;

}
a.none {
  text-decoration: none;
  font-size:30px;
  color:#666!important;
}
a.none:hover {
  text-decoration: none;
  font-size:30px;
  color:#666!important;
}

a.act {
    margin: 10px auto;
    width: 150px;
    padding: 10px;
    display: block;
    background: #f8f8f8;
    border-radius: 10px;
    text-align: center;
    text-decoration: none;
}
a.act:hover {
    background: #fff;
    text-decoration: none;
}
a.act span {
    display: block;
}
a.act img {
    height: 50px;
}

a.linkDwn {
    margin-left: 20px;
    width: auto;
    padding: 8px 20px;
    display: block;
    background: #fff;
    border-radius: 10px;
    text-align: left;
    color:#444!important;
    text-decoration: none;
}
a.linkDwn:hover {
    /*background: #aaa;*/
    background: #0f66aa;
    color:#fff!important;
    text-decoration: none;
}
a.linkDwn span {
    display: block;
}
a.linkDwn img {
    height: 20px;
}

div.lesbtns{
    margin-top: 20px; margin-bottom: 10px; text-align: center;
}
  .top {
    background: #043967; /*#0073B4;*/
    /*color: white;*/
    text-align: left;
    margin-bottom: 10px;
  }
  .mode {
    margin-top:6px;
    background: #043967; /*#0073B4;*/
    color: white;
  }
  .top a {
    color: white;
    font-weight: bold;
  }
  .white {
    color: white!important;
  }
</style>
